import React from 'react';
import { warningMessageStyles } from '../../styles/commonStyles';

/**
 * Компонент для отображения предупреждений
 * @param {Object} props - Свойства компонента
 * @param {string} props.message - Текст предупреждения
 * @returns {JSX.Element|null} Компонент предупреждения или null, если сообщение отсутствует
 */
const WarningMessage = ({ message }) => {
  if (!message) return null;
  
  return (
    <div className={warningMessageStyles}>
      {message}
    </div>
  );
};

export default WarningMessage; 